import { authenticationLocalStorage } from "@/utils/constants/localStorage";
import { useNavigate } from "react-router-dom";

const useAuth = () => {
  const navigate = useNavigate();

  const logout = () => {
    authenticationLocalStorage.clear();
    navigate("/login");
  };

  return { logout };
};

export default useAuth;
